import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AppConfigModel } from '../models/app-config.model';
import { DEFAULT_FEATURES } from '../models/features.model';
import ListJson from '../../../assets/files/list.json';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: AppConfigModel | null = null;
  private configUrl = '/assets/app.config.json';

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<AppConfigModel> {
    return this.http.get<AppConfigModel>(this.configUrl).pipe(
      tap(config => {
        this.config = config;
        console.log('App configuration loaded:', config);
      }),
      catchError(error => {
        console.error('Failed to load app configuration:', error);
        // Return default configuration on error
        const defaultConfig: AppConfigModel = {
          analyticURL: '',
          enableLanguageSwitching: true,
          availableLanguages: ['ua', 'ru', 'gb', 'kk'],
          defaultLanguage: 'ua',
          helpDocuments: ListJson,
          features: DEFAULT_FEATURES
        };
        this.config = defaultConfig;
        return of(defaultConfig);
      })
    );
  }

  getConfig(): AppConfigModel | null {
    return this.config;
  }

  getAnalyticURL(): string {
    return this.config?.analyticURL || '';
  }

  isLanguageSwitchingEnabled(): boolean {
    return this.config?.enableLanguageSwitching ?? true;
  }

  getAvailableLanguages(): string[] {
    return this.config?.availableLanguages || ['ua', 'ru', 'gb'];
  }

  getDefaultLanguage(): string {
    return this.config?.defaultLanguage || 'ua';
  }

  getHelpDocuments(): string[] {
    return this.config?.helpDocuments !== undefined ? this.config.helpDocuments : ListJson;
  }
}
